import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-658821fd"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "promotions_details"
};
const _hoisted_2 = {
  class: "content"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "基本信息", -1));

const _hoisted_4 = {
  class: "base_details_content_second"
};
import { $msg } from "@ui/msg";
import BackTitleView from "@com/BackTitleView.vue";
import { ref, reactive } from "vue";
import $ from "@util/base";
import api from "@api/message";
import useRoute from "@util/router";
export default {
  __name: 'MessageDetails',

  setup(__props) {
    const templeteOptions = ref([]);
    const route = useRoute();
    const urlQuery = route.query();
    const readOnly = urlQuery.type == "show";
    var title = "营销短信详情";
    getTempleteList();

    switch (urlQuery.type) {
      case "show":
        title = "营销短信详情";
        getDetails();
        break;

      case "add":
        title = "新增营销短信";
        break;

      case "modify":
        title = "修改营销短信";
        getDetails();
        break;
    }

    const targetOptions = [{
      label: "全体会员",
      value: "all"
    }];
    const basicForm = ref({
      name: null,
      templeteId: null,
      targetType: null
    });
    const basicRules = {
      name: [{
        required: true,
        message: "请输入活动名称",
        trigger: "blur"
      }],
      templeteId: [{
        required: true,
        message: "请选短信模版",
        trigger: "change"
      }],
      targetType: [{
        required: true,
        message: "请选择发送对象",
        trigger: "change"
      }]
    };

    function getTempleteList() {
      api.templeteList(val => {
        templeteOptions.value = val;
        console.log(val);
      });
    }

    const activeName = ref("basic");
    const basicFormRef = ref(null);

    function saveForm(type) {
      basicFormRef.value.validate(valid => {
        if (valid) {
          $.handleCRU(route.query().type, {
            add: () => {
              addData(type);
            },
            modify: () => {
              modifyData(type);
            }
          });
        }
      });
    }

    function addData(type) {
      if (type == 0) {
        api.add(basicForm.value, () => {
          $msg.succ("新增成功");
          back();
        });
      } else {
        api.add(basicForm.value, val => {
          api.send(val.id, () => {
            $msg.succ("发送成功");
            back();
          });
        });
      }
    }

    function modifyData(type) {
      if (type == 0) {
        api.update(basicForm.value, () => {
          $msg.succ("修改成功");
          back();
        });
      } else {
        api.update(basicForm.value, () => {
          api.send(basicForm.value.id, () => {
            $msg.succ("发送成功");
            back();
          });
        });
      }
    }

    function getDetails() {
      api.details(urlQuery.code, val => {
        basicForm.value = val;
      });
    }

    function back() {
      route.go(-1);
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: _unref(title)
        }, null, 8, ["title"]), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form, {
            ref_key: "basicFormRef",
            ref: basicFormRef,
            model: basicForm.value,
            disabled: readOnly,
            rules: basicRules,
            "label-width": "100px",
            class: "base_details_form"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "短信名称",
              prop: "name"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: basicForm.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => basicForm.value.name = $event),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "短信模版",
              prop: "templeteId"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: basicForm.value.templeteId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => basicForm.value.templeteId = $event),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templeteOptions.value, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "发送对象",
              prop: "targetType"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: basicForm.value.targetType,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => basicForm.value.targetType = $event),
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(targetOptions, (item, index) => {
                  return _createVNode(_component_el_option, {
                    key: index,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 64))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])])])]),
          _: 1
        }), _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = $event => _unref(route).go(-1))
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }), !readOnly ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: _cache[4] || (_cache[4] = $event => saveForm(0)),
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存 ")]),
            _: 1
          })) : _createCommentVNode("", true), !readOnly ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: _cache[5] || (_cache[5] = $event => saveForm(1)),
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存并发送")]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }

};